import { CountryCode } from '@carsys/enums/country-code'

export const isRegistrationFrom = (registration = '', countryCode: CountryCode): boolean => {
  const [registrationCountryCode] = registration.split('|')
  return registrationCountryCode === countryCode
}
